module.exports = __webpack_public_path__ + "img/12.64ff7ed1.gif";